import { useState, useEffect } from 'react';

const HEATMAP_DAYS = 120;

const ENGAGEMENT_STATS = [
  { id: 'xp', label: 'XP earned', value: '1,000', meta: 'Next badge: Complete 5 Classes', completion: 0 },
];

export default function Momentum({ userId }) {
  const [heatmapData, setHeatmapData] = useState(() => buildEmptyDays());

  function buildEmptyDays() {
    const today = new Date();
    return Array.from({ length: HEATMAP_DAYS }, (_, index) => {
      const day = new Date(today);
      day.setDate(today.getDate() - (HEATMAP_DAYS - 1 - index));
      return {
        label: day.toLocaleDateString('en-US', { month: 'short', day: 'numeric' }),
        active: false,
      };
    });
  }

  useEffect(() => {
    if (!userId) return;
    fetch(`/api/activity/heatmap/${userId}?days=${HEATMAP_DAYS}`)
      .then((r) => r.json())
      .then(({ days }) => {
        if (!Array.isArray(days)) return;
        setHeatmapData(
          days.map((d) => ({
            label: new Date(d.date + 'T00:00:00Z').toLocaleDateString('en-US', {
              month: 'short',
              day: 'numeric',
              timeZone: 'UTC',
            }),
            active: d.active,
          })),
        );
      })
      .catch(() => { /* silently fall back to empty heatmap */ });
  }, [userId]);

  return (
    <article className="info-card engagement-card" aria-label="Motivation and streaks">
      <div className="engagement-header">
        <div>
          <p className="eyebrow">Momentum</p>
        </div>
        <button type="button" className="pill-btn subtle" aria-label="View habit settings">
          Adjust habits
        </button>
      </div>

      <div className="engagement-row">
        <div className="engagement-heatmap">
          <div className="heatmap-head">
            <span className="engagement-label">120-day focus</span>
          </div>
          <div className="heatmap-grid" role="grid" aria-label="120 day activity heatmap">
            {heatmapData.map((day) => (
              <span
                key={day.label}
                className={`calendar-cell heatmap-cell ${day.active ? 'active' : ''}`}
                title={`${day.label} · ${day.active ? 'active' : 'no activity'}`}
                role="gridcell"
              />
            ))}
          </div>
        </div>

        {ENGAGEMENT_STATS.map((stat) => (
          <div key={stat.id} className="engagement-stat">
            <span className="engagement-label">{stat.label}</span>
            <span className="engagement-value">
              {stat.id === 'xp' ? '🏆 ' : ''}
              {stat.value}
            </span>
            {stat.id === 'xp' && (
              <div className="engagement-progress" aria-label="Progress to next badge">
                <div className="engagement-progress-track">
                  <div
                    className="engagement-progress-fill"
                    style={{ width: `${stat.completion ?? 0}%` }}
                  />
                </div>
              </div>
            )}
            <span className="engagement-meta">{stat.meta}</span>
          </div>
        ))}
      </div>
    </article>
  );
}
